import React, { useContext, useEffect, useRef, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';
import { LoadBarProps } from './types';
import {
  LoadBarContainer,
  ProgressBar,
  ProgressBarContainer,
  TotalAmountContainer,
  UncompletedBar,
  UncompletedBarContainer,
} from './styles';

const LoadBar = ({ total, progress }: LoadBarProps) => {
  if (progress > total) {
    throw new Error('Progress must be lesser or equal than total');
  }
  if (total <= 0) {
    throw new Error('Total must be greater than 0');
  }

  const { actualTheme } = useContext(ThemeContext);
  const totalAmountRef = useRef<HTMLDivElement>(null);
  const progressBarRef = useRef<HTMLDivElement>(null);
  const totalBarRef = useRef<HTMLDivElement>(null);
  const [showTotalAmount, setShowTotalAmount] = useState(true);
  const [progressText, setProgressText] = useState<string | number>(progress);

  useEffect(() => {
    if (totalAmountRef.current && progressBarRef.current && totalBarRef.current) {
      setShowTotalAmount(
        totalBarRef.current.clientWidth - progressBarRef.current.clientWidth >
          totalAmountRef.current.clientWidth + 6,
      );
    }
  }, [progress]);

  useEffect(() => {
    const progressTextAux = !showTotalAmount ? `${progress}/${total}` : progress;
    setProgressText(progress === 0 ? '' : progressTextAux);
  }, [progress, showTotalAmount, total]);

  return (
    <ThemeProvider theme={actualTheme}>
      <LoadBarContainer ref={totalBarRef}>
        <UncompletedBarContainer cols={total}>
          <UncompletedBar xxs={total}>
            <TotalAmountContainer ref={totalAmountRef} showTotalAmount={showTotalAmount}>
              {total}
            </TotalAmountContainer>
          </UncompletedBar>
        </UncompletedBarContainer>
        <ProgressBarContainer cols={total}>
          <ProgressBar xxs={progress} progress={progress} ref={progressBarRef}>
            {progressText}
          </ProgressBar>
        </ProgressBarContainer>
      </LoadBarContainer>
    </ThemeProvider>
  );
};

export default LoadBar;
